import { Component, OnInit, Input } from '@angular/core';
import { NgIf } from '@angular/common';
import { ProductListComponent } from '../product-list/product-list.component';

@Component({
    selector: 'pdp-product-slider-horizontal',
    templateUrl: './product-slider-horizontal.component.html',
    styleUrls: ['./product-slider-horizontal.component.scss'],
    imports: [NgIf, ProductListComponent]
})
export class ProductSliderHorizontalComponent implements OnInit {

  @Input()
  public sliderId: string;

  @Input()
  public featuredCategory: any;

  constructor() { }

  ngOnInit() {}
}
